import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {UserService} from '../../../../../../../chat-common/src/lib/services/user.service';
import {UserInfoService} from '../../../../../../../chat-common/src/lib/services/user.info.service';
import {UserProfile, UserUnits} from '../../../../../../../chat-common/src/lib/models/user';


@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  profile: UserProfile = new UserProfile();
  editing: { dob: boolean; height: boolean; weight: boolean } = { dob: false, height: false, weight: false };
  userUnits: UserUnits = new UserUnits();
  constructor(private userInfo: UserInfoService, private userService: UserService) {}

  async ngOnInit() {
    const existing = await this.userInfo.getUserProfile();
    if (existing) {
      this.profile = { ...this.profile, ...existing };
    } else {
      // fallback from old realtime DB if exists
      const anyProfile: any = this.userService.user?.profile;
      if (anyProfile) {
        this.profile = { ...this.profile, ...anyProfile } as UserProfile;
      }
    }

    const units = await this.userInfo.getUserUnits();
    if (units) this.userUnits = { ...this.userUnits, ...units };
  }

  async setUnit<K extends keyof UserUnits>(key: K, value: UserUnits[K]) {
    // update local state
    this.userUnits = { ...this.userUnits, [key]: value } as UserUnits;
    // save immediately
    await this.userInfo.saveUserUnits({ [key]: value } as Partial<UserUnits>);
  }

  async save() {
    // Persist relevant fields
    await this.userInfo.saveUserName(this.profile.name || null);
    await this.userInfo.saveUserDateOfBirth(this.profile.dateOfBirth || null);
    // Save height/weight inside profile doc using user.info service directly
    // Reuse Firestore via user.info service
    const uid = this.userService.user.id;
    // use user.service firestore to set profile document generically
    // but user.info.service exposes no generic save - extend via user.service
    await this.userService.saveProfile({
      name: this.profile.name ?? null,
      dateOfBirth: this.profile.dateOfBirth ?? null,
      heightInCm: this.profile.heightInCm ?? null,
      weightInKg: this.profile.weightInKg ?? null,
      weightMeasurementDate: this.profile.weightMeasurementDate ?? null,
      userCreated: this.profile.userCreated ?? null,
    });
  }

  toggle(field: 'dob'|'height'|'weight') {
    this.editing[field] = !this.editing[field];
  }
}
